import React from "react";
import {
  Grid,
  Box,
  Card,
  Typography,
  Tooltip,
  tooltipClasses,
  Link,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components/macro";
import { useStyles } from "../../../pages/UserPages/UserListing/Styles/style";
import ErrorIcon from "../../../assets/images/ErrorIcon.svg";
import CommonButton from "../Buttons/CommonButton";
import Googleicon from "../../../assets/Icons/Group.svg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { api } from "../../../contexts/JWTContext";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    placement="top-start"
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#1B2430",
    borderRadius: "8px",
  },
}));

const GoogleTokenPermission = ({
  location,
  displayReconnectButton,
  addPermission,
  editPermission,
  deletePermission,
  viewPermission,
  onClose,
  googleConnect,
  handleClose,
  fromReviewsPage,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  console.log(googleConnect, "googleConnect");
  const handleNavigation = () => {
    navigate(`/user/token-expire/location/${location?.id}`);
  };

  const handleNavigationToLocations = () => {
    navigate(`/user/locations`);
  };

  const handleTransferOwnership = async () => {
    setIsLoading(true);
    try {
      const res = await api.delete(
        `/socialLink/${googleConnect !== null ? googleConnect?.id : ""}`
      );

      if (res.status === 200) {
        setIsLoading(false);
        const response = await api.get(`googleConnect/auth-url`);
        if (response.data?.status === true) {
          window.location.href = response?.data.data + "&state=reconnect";
        }
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.message);
    }
  };

  const handleTransferOwnershipBulk = async () => {
    const socialLinkIds = location.map((loc) =>
      loc?.socialLink !== null ? loc?.socialLink?.id : null
    );
    setIsLoading(true);
    try {
      const res = await api.delete(
        `/socialLink/bulk?ids=${socialLinkIds.join(",")}`
      );

      if (res.status === 200) {
        setIsLoading(false);
        const response = await api.get(`googleConnect/auth-url`);
        if (response.data?.status === true) {
          window.location.href = response?.data.data + "&state=reconnect";
        }
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.message);
    }
  };

  const handleDisplayEmails = (locations) => {
    let emails = [];
    locations.forEach((loc) => {
      if (loc?.socialLink !== null && loc?.socialLink?.email) {
        emails.push(loc.socialLink.email);
      }
    });
    return emails.join(", ");
  };

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Box
          sx={{
            backgroundColor: "#FFF3CD",
            border: "1px solid #FFEAA7",
            borderLeft: "4px solid #F39C12",
            borderRadius: "4px",
            padding: "12px 16px",
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
            margin: "16px 0",
          }}
        >
          {/* Info Icon */}
          <InfoOutlinedIcon
            sx={{
              color: "#F39C12",
              fontSize: "20px",
              marginTop: "2px",
              flexShrink: 0,
            }}
          />
          {fromReviewsPage === true && (
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#000000",
                  fontSize: "12px",
                  lineHeight: "20px",
                  margin: 0,
                }}
              >
                <strong>{t("Access_Restricted")}</strong>{" "}
                {t("tokenPermissionDes1")} {handleDisplayEmails(location)}{" "}
                {t("tokenPermissionDes2")} {"  "}
                {isLoading ? (
                  <CircularProgress
                    size={16}
                    style={{
                      marginLeft: "5px",
                      marginTop: "5px",
                    }}
                  />
                ) : (
                  <Link
                    href="#"
                    onClick={handleTransferOwnershipBulk}
                    sx={{
                      color: "#000000",
                      textDecoration: "underline",
                      cursor: "pointer",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {t("tokenPermissionCTA")}
                  </Link>
                )}
              </Typography>
            </Box>
          )}
          {/* Content */}
          {googleConnect !== null && fromReviewsPage === false && (
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#000000",
                  fontSize: "12px",
                  lineHeight: "20px",
                  margin: 0,
                }}
              >
                <strong>{t("Access_Restricted")}</strong>{" "}
                {t("tokenPermissionDes1")} {googleConnect?.email}{" "}
                {t("tokenPermissionDes2")} {"  "}
                {isLoading ? (
                  <CircularProgress
                    size={16}
                    style={{
                      marginLeft: "5px",
                      marginTop: "5px",
                    }}
                  />
                ) : (
                  <Link
                    href="#"
                    onClick={handleTransferOwnership}
                    sx={{
                      color: "#000000",
                      textDecoration: "underline",
                      cursor: "pointer",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {t("tokenPermissionCTA")}
                  </Link>
                )}
              </Typography>
            </Box>
          )}

          {/* Close Button */}
          <IconButton
            size="small"
            onClick={handleClose}
            sx={{
              color: "#000000",
              padding: "4px",
              marginTop: "-4px",
              marginRight: "-8px",
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Grid>
    </>
  );
};

export default GoogleTokenPermission;
